import Layout from "@components/Layout";
import ArtsContainer from "@containers/ArtsContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import { getServer } from "@translations/next";
import _ from "lodash";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";

export default function About(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <ArtsContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}
// export { getServerSideProps };
export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel10-art");
  const res = await StrapiService.find({ populate: "deep", locale });

  // Get Stay Connected
  StrapiService.set("id", "hotel10-stay-connected");
  const resInspired = await StrapiService.find({
    populate: "deep",
    locale,
  });
  const footerData = await FooterService.fetchByHotel("amanaki-thao-dien", locale);

  return {
    hotel: "amanaki-thao-dien",
    pageData: {
      ..._.get(res, "data", {}),
      stayConnected: _.get(resInspired, "data", {}),
    },
    metatags: _.get(res, "data.attributes.metatags", {}),
    footerData,
  };
});
